import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useLocale } from "@/contexts/LanguageContext";

export function SEOHead() {
  const { locale } = useLocale();
  const location = useLocation();

  useEffect(() => {
    const baseUrl = window.location.origin;
    const currentPath = location.pathname;

    // Remove existing hreflang links
    document.querySelectorAll('link[rel="alternate"][hreflang]').forEach(el => el.remove());

    // Compute equivalent paths
    let enPath: string;
    let esPath: string;

    if (currentPath.startsWith("/es")) {
      esPath = currentPath;
      enPath = currentPath.replace(/^\/es/, "") || "/";
    } else {
      enPath = currentPath;
      esPath = "/es" + (currentPath === "/" ? "" : currentPath);
    }

    // Add hreflang tags
    const hreflangs = [
      { lang: "en", href: `${baseUrl}${enPath}` },
      { lang: "es", href: `${baseUrl}${esPath}` },
      { lang: "x-default", href: `${baseUrl}${enPath}` },
    ];

    hreflangs.forEach(({ lang, href }) => {
      const link = document.createElement("link");
      link.rel = "alternate";
      link.hreflang = lang;
      link.href = href;
      document.head.appendChild(link);
    });

    return () => {
      document.querySelectorAll('link[rel="alternate"][hreflang]').forEach(el => el.remove());
    };
  }, [locale, location.pathname]);

  return null;
}
